import { ComponentToPrint } from './ComponentToPrintLab';
import React, { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import ticket from "../../../assets/font-awesome/black/png/128/print.png";

function Preview({ item }) {
  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current
  });

  console.log("ini status print lab", item)
  return (
    <div className="bg-gray-200 p-6" style={{cursor: item.STATUS == "PERIKSA LAB" ? null : 'not-allowed' }}>
      <button disabled={item.STATUS == "PERIKSA LAB" ? false : true} onClick={handlePrint} className={item.STATUS == "PERIKSA LAB" ? "btn btn-info btn-sm rounded-0" : "btn btn-light btn-sm rounded-0"} style={{ backgroundImage: "url(" + ticket + ")", backgroundSize: "cover", backgroundSize: '20px', backgroundPosition: 'center', backgroundRepeat: 'no-repeat', width: "30px", height: "30px" }}></button>
      <ComponentToPrint item={item} ref={componentRef} />
    </div>
  );
}

export default Preview;



